import React from 'react';
import { Link } from 'react-router-dom';
import { DEFAULT_LOCAL_PATH } from '../../constents';
import { post } from '../Auths/AuthToken';
import { useState } from 'react';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import setUiMessage from '../../Utilities/Tostify';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import ToolTip from '../../Utilities/ToolTip';

function PriorAuthList({
  item,
  fromPat = false,
  handlePopupOpen,
  handleReload,
}) {
  const [authId, setAuthId] = useState('');
  const [docs, setDocs] = useState([]);
  const [openDocsViewer, setOpenDocsViewer] = useState(false);
  const [deletePriorAuth, setDeletePriorAuth] = useState(false);
  const [openToolTip, setOpenToolTip] = useState(false);

  const handleDocsViewerOpen = async (authId, patientId) => {
    const response = await post(
      'api/patient/ManagePriorAuth/openAuthorizationPopup',
      {
        patientId: patientId,
        authId: authId,
      }
    );
    if (response.status === 200) {
      let docsArr = [];

      if (response.data.allAttachArr?.length > 0) {
        response.data.allAttachArr?.map((item, i) =>
          docsArr.push({ uri: item?.filePath })
        );
      }
      setDocs(docsArr);
      if (docsArr.length > 0) {
        setOpenDocsViewer(true);
      }
    }
  };

  const handleDeletePriorAuth = async (authId) => {
    setAuthId(authId);
    setDeletePriorAuth(true);
  };

  const handleChangePatStatusConfirm = async (authId) => {
    const response = await post('api/patient/ManagePriorAuth/deleteAuth', {
      authId: authId,
    });
    if (response.status === 200) {
      handleReload();
      setUiMessage('suc', 'Data delete successfully.');
      setDeletePriorAuth(false);
    }
  };

  return (
    <>
      <span
        className={fromPat ? 'pacolm4 pa-pt-name hide' : 'pacolm4 pa-pt-name'}
      >
        <Link to={`${DEFAULT_LOCAL_PATH}/patient/counNote/${item?.patientId}`}>
          {item?.patName} - {item?.age} [{item?.gender}]
        </Link>
        <br />
        {item?.dob}
      </span>
      <span className={fromPat ? 'pacolm5 hide' : 'pacolm5'}>
        {item?.chart_number}
      </span>
      <span className="pacolm3 hide"></span>
      <span className="pacolm4">
        {item?.payorName}
        <br />
        <span className="sec-colr">Subscriber Id: {item?.subscriber_id}</span>
      </span>
      <span className="pacolm5">{item?.procCode}</span>
      <span className="pacolm5">
        <>
          {item?.mod1 && (
            <>
              {item.mod1Title}
              <br />
            </>
          )}
          {item?.mod2 && (
            <>
              {item.mod2Title}
              <br />
            </>
          )}
          {item?.mod3 && (
            <>
              {item.mod3Title}
              <br />
            </>
          )}
          {item?.mod4 && <>{item.mod4Title}</>}
        </>
      </span>
      <span className="pacolm4">{item?.procName}</span>
      <span
        className={
          (item?.authStatus === 'Requested' && 'pacolm5 red') ||
          (item?.authStatus === 'Approved' && 'pacolm5 green-txt') ||
          'pacolm5'
        }
      >
        {item?.authStatus} <br />
        {item?.requestDt}
      </span>
      <span className="pacolm5">{item?.fromDate}</span>
      <span className="pacolm5">{item?.toDate}</span>
      <span className="pacolm5">{item?.totalUnit}</span>
      <span className="pacolm5">{item?.usedUnit}</span>
      <span className="pacolm5">
        {item?.totalUnit &&
          item?.usedUnit &&
          parseInt(item?.totalUnit) - parseInt(item?.usedUnit)}
      </span>
      <span className="pacolm1">{item?.prioAuthNo}</span>
      <span className="pacolm5">
        {item?.attach?.num > 0 ? (
          <Link
            className=""
            onClick={() => handleDocsViewerOpen(item?.authId, item?.patientId)}
          >
            View
          </Link>
        ) : (
          <span>View</span>
        )}
      </span>
      <span className="pacolm5" style={{ position: 'relative' }}>
        {!item?.note ? (
          <span>View</span>
        ) : (
          <Link
            className=""
            onClick={() => {
              !!item?.note
                ? setOpenToolTip(true)
                : setUiMessage('war', 'Note not available');
            }}
          >
            View
          </Link>
        )}

        {openToolTip && item?.note && (
          <ToolTip
            content={item?.note}
            setOpenToolTip={() => setOpenToolTip(false)}
          />
        )}
      </span>
      <span className="pacolm5">{item?.activeStatus}</span>
      <span className="pacolm4">
        <Link
          className=""
          onClick={() => handlePopupOpen(item?.authId, item?.patientId)}
        >
          Change
        </Link>
        <span className="red"> | </span>
        <Link className="" onClick={() => handleDeletePriorAuth(item?.authId)}>
          Remove
        </Link>
      </span>
      {openDocsViewer > 0 && (
        <div className="modalBackground">
          <div
            className="center-popup"
            style={{
              backgroundColor: '#fff',
              position: 'absolute',
            }}
          >
            <div className="main-contnr-hdr flex-sec white-bg">
              <div className="hdr-pt-info">Document viewer</div>
              <div className="close" onClick={() => setOpenDocsViewer(false)}>
                X
              </div>
            </div>
            <div style={{ width: '700px', height: '500px' }}>
              {docs.length > 0 && (
                <DocViewer
                  documents={docs}
                  initialActiveDocument={docs[0]}
                  pluginRenderers={DocViewerRenderers}
                />
              )}
            </div>
          </div>
        </div>
      )}
      {deletePriorAuth && (
        <ConfirmDialog
          title="Prior Authorization"
          bodytext={'Do you want to delete this authorization?'}
          closeDialog={() => setDeletePriorAuth(false)}
          successDialog={handleChangePatStatusConfirm}
          sucPrams={authId}
        />
      )}
    </>
  );
}

export default PriorAuthList;
